var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10q.625 0 1.062-.438Q12 9.125 12 8.5t-.438-1.062Q11.125 7 10.5 7t-1.062.438Q9 7.875 9 8.5t.438 1.062Q9.875 10 10.5 10Zm-2 5q.625 0 1.062-.438Q10 14.125 10 13.5t-.438-1.062Q9.125 12 8.5 12t-1.062.438Q7 12.875 7 13.5t.438 1.062Q7.875 15 8.5 15Zm6.5 1q.425 0 .713-.288Q16 15.425 16 15t-.287-.713Q15.425 14 15 14t-.712.287Q14 14.575 14 15t.288.712Q14.575 16 15 16Zm-3 6q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12q0-2.1.9-4.1.9-2 2.513-3.45Q7.025 3 9.238 2.325q2.212-.675 4.837-.125-.225 1.125.15 2.112.375.988 1.125 1.663t1.775.925q1.025.25 2.15-.125-.775 1.725.275 2.95T21.95 11q.225 2.225-.475 4.225-.7 2-2.062 3.5-1.363 1.5-3.275 2.388Q14.225 22 12 22Zm0-2q3.05 0 5.413-2.1 2.362-2.1 2.587-5.35-1.25-.55-1.962-1.5-.713-.95-.963-2.125-1.925-.275-3.3-1.65-1.375-1.375-1.7-3.3-2-.05-3.513.725-1.512.775-2.524 1.987Q5.025 7.9 4.513 9.325 4 10.75 4 12q0 3.325 2.338 5.663Q8.675 20 12 20Zm0-8.1Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.a215669eb252b0a069280e6f979746cd.svg";
export { ForwardRef as ReactComponent };